import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StorageHandler } from 'C4';

const StoreButtons = (props) => {
  const { title } = props;

  const [appleStore, setApple] = useState(null);
  const [googlePlay, setGoogle] = useState(null);

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setApple(appInfo.appleStore);
      setGoogle(appInfo.googlePlay);
    }
  };

  useEffect(() => {
    getAppInfo();
  });

  return (
    <React.Fragment>
      {title && <h3>Get the app on your mobile device</h3>}
      <div className="storeButtons__container">
          {appleStore && <a href={appleStore} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={['fab', 'app-store']} />
          </a>}
          {googlePlay && <a href={googlePlay} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={['fab', 'google-play']} />
          </a>}
      </div>
    </React.Fragment>
  );
};

export default StoreButtons;

StoreButtons.propTypes = {
  title: PropTypes.bool,
};

StoreButtons.defaultProps = {
  title: false,
};
